import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { ComplexSuggestedItem } from '../../../../ui/gzComplexEnumList/types';
import { ENTITIES_CLASS, RESOURCES_CLASS } from '../../types';
import {IncidentsItems} from "./IncidentsItems";

export class IncidentsResources extends IncidentsItems {
  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @param filters
   * @protected
   */
  static async getRemoteData(page, limit, searchString: string = '', filters: Array<any> = []): Promise<Array<any>> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'UnifiedIncidents',
      method: 'getIncidentsResources',
      payload: {
        page,
        limit,
        searchString,
        filters
      },
    });
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response): ComplexSuggestedItem[] {
    return response;
  }

  static getTypeToIconMapping() {
    return RESOURCES_CLASS;
  }
}
